import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    item: {
        backgroundColor: theme.palette.grey[900],
        height: "100%",
        width: "100%",
    },
}));
